import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/marken/bmw/Bmw.js");
